module.exports = __webpack_public_path__ + "img/ttl_thanks.119b1f14.svg";